export const T = {
  en_GB: {
    loadingRiskAssessment: "Loading risk assessment...",
    riskModelNotFound: "Risk model not found. Please contact support.",
    timeHorizon: "Time Horizon",
    riskTolerance: "Risk Tolerance",
    incompleteMessage: "Complete the risk assessment",
    notScoredMessage:
      "The risk model has no score for the selected time horizon and risk level, so no goal could be scored. Check the risk model's matrix.",
  },
  nb_NO: {
    loadingRiskAssessment: "Laster risikovurdering...",
    riskModelNotFound: "Risikomodell ikke funnet. Vennligst kontakt support.",
    timeHorizon: "Tidshorisont",
    riskTolerance: "Risikotoleranse",
    incompleteMessage: "Fullfør risikovurderingen",
    notScoredMessage:
      "Risikomodellen har ingen score for valgt tidshorisont og risikonivå, så ingen mål kunne scores. Sjekk risikomodellens matrise.",
  },
} as const;
